var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "de-container",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.$store.getters.loadingMap[_vm.$store.getters.currentPath],
          expression: "$store.getters.loadingMap[$store.getters.currentPath]",
        },
      ],
      class: _vm.isAbsoluteContainer ? "abs-container" : "",
    },
    [
      _c(
        "de-main-container",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showChartCanvas,
              expression: "showChartCanvas",
            },
          ],
        },
        [
          _c(
            "div",
            {
              staticClass: "canvas-class",
              style: _vm.customStyle,
              attrs: { id: "chartCanvas" },
            },
            [
              _c(
                "div",
                { staticClass: "canvas-class", style: _vm.commonStyle },
                [
                  _vm.chart.isPlugin
                    ? _c("plugin-com", {
                        staticClass: "chart-class",
                        attrs: {
                          "component-name": _vm.chart.type + "-view",
                          obj: { chart: _vm.mapChart || _vm.chart },
                          chart: _vm.mapChart || _vm.chart,
                          "theme-style": _vm.element.commonBackground,
                          "canvas-style-data": _vm.canvasStyleData,
                        },
                      })
                    : !_vm.chart.type.includes("text") &&
                      _vm.chart.type !== "label" &&
                      !_vm.chart.type.includes("table") &&
                      _vm.renderComponent() === "echarts"
                    ? _c("chart-component", {
                        staticClass: "chart-class",
                        attrs: {
                          "theme-style": _vm.element.commonBackground,
                          chart: _vm.mapChart || _vm.chart,
                        },
                      })
                    : !_vm.chart.type.includes("text") &&
                      _vm.chart.type !== "label" &&
                      !_vm.chart.type.includes("table") &&
                      _vm.renderComponent() === "antv"
                    ? _c("chart-component-g2", {
                        staticClass: "chart-class",
                        attrs: { chart: _vm.chart },
                      })
                    : _vm.chart.type.includes("table") &&
                      _vm.renderComponent() === "antv"
                    ? _c("chart-component-s2", {
                        staticClass: "chart-class",
                        attrs: { chart: _vm.chart },
                      })
                    : _vm.chart.type.includes("text")
                    ? _c("label-normal", {
                        staticClass: "table-class",
                        attrs: { chart: _vm.chart },
                      })
                    : _vm.chart.type === "label"
                    ? _c("label-normal-text", {
                        staticClass: "table-class",
                        attrs: { chart: _vm.chart },
                      })
                    : _vm.chart.type.includes("table") &&
                      _vm.renderComponent() === "echarts"
                    ? _c("table-normal", {
                        staticClass: "table-class",
                        attrs: { chart: _vm.chart },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _c(
        "de-main-container",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.showChartCanvas,
              expression: "!showChartCanvas",
            },
          ],
        },
        [
          _c("table-normal", {
            staticClass: "table-class-dialog",
            attrs: {
              "enable-scroll": false,
              chart: _vm.chartTable,
              "show-summary": false,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }